<template>
  <div class="nav-container">
    <div v-if="showMenuApp && !isIpad">
      <el-drawer
        :withHeader="false"
        :visible.sync="showApp"
        direction="ltr"
        size="300px"
        :modal-append-to-body="false"
        :wrapperClosable="true"
      >
        <!-- 用户信息 -->
        <div class="wap-top">
          <img src="https://master-shopvidi.s3.amazonaws.com/index_images/mobile_logo%403x.png" />
          <p v-if="login">
            <span style="width: auto; padding: 0 10px"
              >Hello,{{ realname }}</span
            >
          </p>
          <p v-else>
            <span @click="showLoginHandle">Login</span>
            <span v-if="isPre" @click="showSdrLogin">SDR/SR</span>
            <span @click="showLoginUpHandle">Sign Up</span>
          </p>
        </div>
        <!-- <div v-if="login && ((isFirstOrder&&isShowNt)||!isFirstOrder)"> -->
        <!-- 1.7.1 NT支付优化 修改 haoyuanw -->
        <div v-if="isUseNt">
        <!-- 在移动端的的部分加上 预申请信用支付的部分 -->
        <!-- 申请成功有值-->
        <template v-if="(pcPayMenthod.pcNetQualificationStatus=='completed'||pcPayMenthod.pcNetQualificationStatus=='approved')">
          <div class="apply-border" >
            <div class="info" >
              <!-- add by cpgu 2022/09/14 begin -->
              <div class="net-term" v-if="!netPayable">
                <p @click="$router.push({name: 'profile'})">Open net term payment</p>
                <p>{{tooltipText.split(",")[0]}}</p>
              </div>
              <!-- end by cpgu -->
              <template v-else>
                <div class="info-name">
                  <span>Net terms</span>
                  <span class="status color-green">Active</span>
                </div>
                <div class="money_box">
                  <div>
                    <div class="money" v-if="pcPayMenthod.creditLimit">
                      <div>${{pcPayMenthod.totalCreditLimit | numFormat}}</div>
                      <!-- 没有品牌优惠额度，提额入口 -->
                      <template v-if="!pcPayMenthod.exclusiveAvailableLimit">
                        <div class="shoping_button" v-if="increaseStatus"  @click="$router.push({name:'apply'})" >Increase My Limit</div>
                        <div class="shoping_button" v-else >Review increase limit</div>
                      </template>
                    </div>
                    <div class="info-desc" v-if="pcPayMenthod.creditLimit">Credits available</div>
                  </div>
                  <div class="line_between" v-if="pcPayMenthod.exclusiveAvailableLimit "></div>
                  <div class="money_box_right" v-if="pcPayMenthod.exclusiveAvailableLimit ">
                    <div class="money"><div>${{pcPayMenthod.exclusiveAvailableLimit}}</div></div>
                    <div class="info-desc">{{pcPayMenthod.exclusiveBrandName}} Credits</div>
                  </div>
                </div>

                <!-- 如果存在品牌优惠额度和net额度，则提额入口，单独一行显示 add by cpgu 20220914-->
                <template v-if="pcPayMenthod.exclusiveAvailableLimit">
                  <div style="margin-top: 15px;margin-left: 0px;" v-if="increaseStatus"  class="shoping_button" @click="$router.push({name:'apply'})" >Increase My Limit</div>
                  <div style="margin-top: 15px;margin-left: 0px;" v-else  class="shoping_button" >Review increase limit</div>
                </template>
                <!-- end by cpgu 2022/09/14 -->
              </template>

            </div>
          </div>
        </template>
        <template v-if="pcPayMenthod.pcNetQualificationStatus=='declined' || pcPayMenthod.pcNetQualificationStatus=='disabled'">
          <div class="apply-border">
            <div class="info">
              <!-- add by cpgu 2022/09/14 begin -->
              <div class="net-term" v-if="!netPayable">
                <p @click="$router.push({name: 'profile'})">Open net term payment</p>
                <p>{{tooltipText.split(",")[0]}}</p>
              </div>
              <!-- end by cpgu -->
              <template v-else>
                <div class="info-name">
                  <span>Net terms</span>
                  <span :class="pcPayMenthod.pcNetQualificationStatus=='declined'?'status color-red':'status color-brown'">{{pcPayMenthod.pcNetQualificationStatus | toFirstUpper}}</span>
                </div>
                <!-- add by cpgu 2022/09/15 begin -->
                <div class="net-term">
                  <p style="cursor: none;text-decoration: none;">Contact Customer Service</p>
                  <p style="font-size: 12px;">To unlock the net term status</p>
                </div>
                <!-- end by cpgu -->
              </template>

            </div>
            <!-- <div class="type" @click="addItems">Apply for Terms</div> -->
          </div>
        </template>
        <!-- <template v-if="(limit.qualificationStatus=='completed'||limit.qualificationStatus=='approved')">
          <div class="apply-border" >
            <div class="info" >
              <div class="info-name">
                <span>Net terms</span>
                <span class="status color-green">Active</span>
              </div>
               申请成功之后的话，是否显示额度，是看 额度是否有值，如果没有 说明是banks申请的
              <div class="money" v-if="limit.creditLimit">${{limit.creditLimit | numFormat}}</div>
              <div class="info-desc" v-if="limit.creditLimit">Credits available</div>
            </div>
          </div>
        </template> -->
        <!-- pending -->
        <template v-if="!pcPayMenthod.pcNetQualificationStatus">
          <div class="apply-border">
            <div class="info">
              <!-- add by cpgu 2022/09/14 begin -->
              <div class="net-term" v-if="!netPayable">
                <p @click="$router.push({name: 'profile'})">Open net term payment</p>
                <p>{{tooltipText.split(",")[0]}}</p>
              </div>
              <!-- end by cpgu -->

              <template v-else>
                <div class="info-name">
                  <span>Net terms</span>
  <!--                <span class="status color-red">Inactivated</span>-->
                  <el-tooltip class="item" effect="dark" :content="tooltipText" placement="top">
                    <i class="el-icon-warning-outline" style="font-size:20px"></i>
                  </el-tooltip>
                </div>

                <div class="money_box" v-if="netPayable">
                  <div>
                    <div class="money">
                      <div>${{pcPayMenthod.totalCreditLimit | numFormat}}</div>
                      <!-- 没有品牌优惠额度，提额入口 add by cpgu -->
                      <template v-if="!pcPayMenthod.exclusiveAvailableLimit">
                        <div class="shoping_button" v-if="increaseStatus"  @click="$router.push({name:'apply'})" >Increase My Limit</div>
                        <div class="shoping_button" v-else >Review increase limit</div>
                      </template>
                    </div>
                    <div class="info-desc">Credits available</div>
                  </div>
                  <div class="line_between" v-if="pcPayMenthod.exclusiveAvailableLimit"></div>
                  <div class="money_box_right" v-if="pcPayMenthod.exclusiveAvailableLimit">
                    <div class="money"><div>${{pcPayMenthod.exclusiveAvailableLimit}}</div></div>
                    <div class="info-desc">{{pcPayMenthod.exclusiveBrandName}} Credits</div>
                  </div>
                </div>
                <!-- add by cpgu 2022/09/14 如果存在品牌优惠额度和net额度，则提额入口，单独一行显示 begin-->
                <template v-if="pcPayMenthod.exclusiveAvailableLimit">
                  <div style="margin-top: 15px;margin-left: 0px;" v-if="increaseStatus"  class="shoping_button" @click="$router.push({name:'apply'})" >Increase My Limit</div>
                  <div style="margin-top: 15px;margin-left: 0px;" v-else  class="shoping_button" >Review increase limit</div>
                </template>
                <!--- end by cpgu -->
              </template>

            </div>
            <!-- <div class="type" @click="addItems">Apply for Terms</div> -->
          </div>
        </template>
        <!-- decline -->
        <!-- <template v-if="limit.qualificationStatus=='declined'">
          <div class="apply-border">
            <div class="info">
              <div class="info-name">
                <span>Net terms</span>
                <span class="status color-red">{{limit.qualificationStatus}}</span>
              </div>
              <div class="money">${{limit.creditLimit | numFormat}}</div>
              <div class="info-desc">Credits available</div>
            </div>
            <div class="type" @click="addItems">Apply for Terms</div>
          </div>
        </template> -->
        <!-- in Review -->
        <template v-if="pcPayMenthod.pcNetQualificationStatus === 'inReview' || pcPayMenthod.pcNetQualificationStatus === 'frozen'">
          <div class="apply-border">
            <div class="info">
              <!-- add by cpgu 2022/09/14 begin -->
              <div class="net-term" v-if="!netPayable">
                <p @click="$router.push({name: 'profile'})">Open net term payment</p>
                <p>{{tooltipText.split(",")[0]}}</p>
              </div>
              <!-- end by cpgu -->

              <template v-else>
              <div class="info-name">
                <span>Net terms</span>
                <span v-if="pcPayMenthod.pcNetQualificationStatus !== 'inReview'" :class="pcPayMenthod.pcNetQualificationStatus === 'inReview'?'status color-gray':'status color-blue'">{{pcPayMenthod.pcNetQualificationStatus | toFirstUpper}}</span>
              </div>
              <!-- 冻结(添加以下if) add by cpgu 2022/09/15 -->
              <div class="net-term" v-if="pcPayMenthod.pcNetQualificationStatus === 'frozen'">
                <p style="cursor: none;text-decoration: none;">Contact Customer Service</p>
                <p style="font-size: 12px;">To unlock the net term status</p>
              </div>
              <div v-else class="money_box">
                <div>
                  <div class="money">
                    <div>${{pcPayMenthod.totalCreditLimit | numFormat}}</div>
                    <!-- 没有品牌优惠额度，提额入口 -->
                    <template v-if="!pcPayMenthod.exclusiveAvailableLimit">
                      <div class="shoping_button" v-if="increaseStatus"  @click="$router.push({name:'apply'})" >Increase My Limit</div>
                      <div class="shoping_button" v-else >Review increase limit</div>
                    </template>
                  </div>
                  <div class="info-desc">Credits available</div>
                </div>
                <div class="line_between" v-if="pcPayMenthod.exclusiveAvailableLimit" ></div>
                <div class="money_box_right" v-if="pcPayMenthod.exclusiveAvailableLimit ">
                  <div class="money"><div>${{pcPayMenthod.exclusiveAvailableLimit}}</div></div>
                  <div class="info-desc">{{pcPayMenthod.exclusiveBrandName}} Credits</div>
                </div>
              </div>
              </template>

            </div>
          </div>
        </template>
      </div>
        <!-- 菜单 -->
        <div class="wap-body">
          <!--二三级菜单-->
          <div class="wap-child" v-if="showMenu && firstListName">
            <h3>
              {{ firstListName }}
              <i class="el-icon-arrow-left" @click="showMenu = false"></i>
            </h3>
            <h4 @click="mobileGotoMenu(1)" v-if="currentItem['barType']!='collection' || firstListName==='Featured'">All {{ firstListName }}</h4>
            <el-collapse
              @change="collapseChange"
              v-model="activeNames"
              :accordion="true"
            >
              <el-collapse-item
                v-for="(item, index) in secondListNew"
                :key="index"
                :title="item.name"
                :name="index.toString()"
              >
                <h4 @click="mobileGotoMenu(2,item)" style="line-height: 30px">
                  All {{ item.name }}
                </h4>
                <div
                  class="wap-nav"
                  v-for="(obj, id) in thirdListNew"
                  :key="id"
                  @click="mobileGotoMenu(3, obj)"
                >
                  {{ obj.name }}
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
          <div class="wap-list" v-else>
            <h4>Categories for You</h4>
            <p
              v-for="(item, id) in navList"
              :key="id"
              @click="showNextMenu(item)"
              v-if="item.cateName !=='Shop By Retailer'"
            >
              {{ item.name }}
              <i class="el-icon-arrow-right"></i>
            </p>

            <el-collapse v-if="login">
              <el-collapse-item>
                <template slot="title">
                  <h4>
                    <i class="el-icon-user"></i>
                    Your Account
                  </h4>
                </template>
                <p>Hello,{{ realname }}</p>
                <div v-for="item in menuList" :key="item.name" v-if="!item.hidden">
                  <a class="first-vidi-menu" @click="selectedMenu(item)">
                    <div class="menu-first">{{ item.name }}</div>
                    <i class="el-icon-arrow-right" v-if="checkedMenu !== item.name"></i>
                    <i class="el-icon-arrow-down" v-else></i>
                  </a>
                  <!-- 二级菜单 -->
                  <div v-if="firstMenuName === item.name">
                    <div v-for="secondMenu in item.childrenList" :key="secondMenu.key">
                      <a  class="second-vidi-menu" @click="gotoRouter(2, secondMenu)">{{ secondMenu.name }}</a>
                    </div>
                  </div>
                </div>
                <!-- <p
                  class="menu-list"
                  v-for="(list, lid) in menuList"
                  :key="lid"
                  @click="gotoPlatform(list)"
                >
                  {{ list.name }}
                  <i class="el-icon-arrow-right" v-if="checkedMenu !== list.name"></i>
                  <i class="el-icon-arrow-down" v-else></i>
                  <span>aaa</span>
                </p> -->
              </el-collapse-item>
            </el-collapse>
            <h4 @click="signOut" v-if="login">Sign Out</h4>
          </div>
        </div>
      </el-drawer>

    </div>

    <!-- 以下为PC端 -->
    <div class="nav-body" v-else>
      <div class="nav" @mouseleave="disableNextMenu">
        <div
          v-for="(item, id) in navList"
          :key="id"
          :class="id == 0 ? 'first' : ''"
          v-if="item.cateName !=='Shop By Retailer'"
          @mouseover="showNextMenu(item)"
        >
          <!-- <i class="el-icon-menu" v-if="id == 0"></i> -->
          <div :class="{ 'first-titel-seleted': item.id === currentItem.id }" v-if="id == 0" @click="gotoCollection(1)">
            {{ item.name }}
          </div>
          <div :class="{ 'first-titel-seleted': item.id === currentItem.id }" v-if="id != 0" @click="gotoProduct(1)">
            {{ item.name }}
          </div>
        </div>
        <el-divider v-if="showMenu"></el-divider>
        <div
          v-if="showMenu"
          class="categery-collection-menu-border"
          @mouseleave="disableNextMenu"
        >
          <div class="categery-collection-menu-content" v-if="firstListName == 'Featured'">
            <div class="second-menu">
              <div>
                <a
                  class="second-left"
                  @click="gotoCollection(1)"
                  href="javascript:void(0)"
                  >All {{ firstListName }}</a
                >
              </div>
              <!-- <div><a class="second-left" @click="gotoProduct('new')" href="javascript:void(0)">New Releases</a></div> -->
              <div>
                <div
                  v-for="(item, index) in secondListNew"
                  :key="index"
                  @mouseenter="changeThird(item)"
                  :class="{
                    'second-content-selected': tempSecondId === item.id,
                    'second-content': tempSecondId !== item.id,
                  }"
                >
                  <a
                    @click="gotoCollection(2,item)"
                    class="second-left-content"
                    href="javascript:void(0)"
                    >{{ item.name }}</a
                  >
                </div>
              </div>
            </div>
            <el-divider direction="vertical"></el-divider>
            <div class="third-menu">
              <div
                v-for="(item, index) in thirdListNew"
                :key="index"
                class="third-menu-border"
              >
                <a
                  class="third-content"
                  @click="gotoCollection(3, item)"
                  href="javascript:void(0)"
                  >{{ item.name }}</a
                >
              </div>
            </div>
          </div>
          <div class="categery-collection-menu-content" v-if="firstListName != 'Featured'">
            <div class="second-menu">
              <div v-if="currentItem['barType']!='collection'">
                <a
                  class="second-left"
                  @click="gotoProduct(1)"
                  href="javascript:void(0)"
                  >All {{ firstListName }}</a
                >
              </div>
              <!-- <div><a class="second-left" @click="gotoProduct('new')" href="javascript:void(0)">New Releases</a></div> -->
              <div>
                <div
                  v-for="(item, index) in secondListNew"
                  :key="index"
                  @mouseenter="changeThird(item)"
                  :class="{
                    'second-content-selected': tempSecondId === item.id,
                    'second-content': tempSecondId !== item.id,
                  }"
                >
                  <a
                    @click="gotoProduct(2,item)"
                    class="second-left-content"
                    href="javascript:void(0)"
                    >{{ item.name }}</a
                  >
                </div>
              </div>
            </div>
            <el-divider direction="vertical"></el-divider>
            <div class="third-menu">
              <div
                v-for="(item, index) in thirdListNew"
                :key="index"
                class="third-menu-border"
              >
                <a
                  class="third-content"
                  @click="gotoProduct(3, item)"
                  href="javascript:void(0)"
                  >{{ item.name }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-divider v-if="!showMenu"></el-divider>
      <div v-show="showMenu" class="footer" />
    </div>

    <!-- add by cpgu 2022/06/13 begin -->
    <div v-if="false" class="on-hold" v-show="showOnHold && (doubleShowOnHold || showMenuApp)">
       <img src="@/assets/img/warning.png">
      <span class="on-hold-text">
        <label>Action required! </label>
        Verify as a retailer, increase your term.</span>
      <span @click="retailerCheck" style="font-size:13px">Start Verification!</span>
    </div>
    <!-- end by cpgu  -->
    <sdrLogin :showSdrLoginDialog="showSdrLoginDialog" @sdrLogin="sdrLogin" @closeSdrLoginDialog="closeSdrLoginDialog"></SdrLogin>
  </div>
</template>

<script>
import Vue from 'vue'
import {loadSysRole} from './loadSysRole.js'
import { getAction, Logout, getCreditLimit } from '@/api/manage.js'
import {closeWebsocket} from '../../utils/ws'
import sdrLogin from './sdr-login.vue'
import { postAction } from '../../api/manage.js'
export default {
  components: { sdrLogin },
  name: 'Head',
  props: ['showLoginUp', 'showLogin', 'isFirstOrder', 'isShowNt'],
  data() {
    return {
      tooltipText: '',
      checkedMenu: '',
      firstMenuName: '',
      menuList: [], // 新的菜单
      tempSecondId: '',
      realname: this.$ls.get('realname') || '',
      meauList: JSON.parse(localStorage.getItem('meauList')) || [],
      navChecked: localStorage.getItem('nav_checked') || '',
      firstListName: localStorage.getItem('first_list_name') || '',
      randomNumber: 111,
      activeNames: [],
      secondListNew: JSON.parse(localStorage.getItem('second_list')) || [],
      thirdListNew: JSON.parse(localStorage.getItem('third_list')) || [],
      secondList: [], // 2级菜单集合
      thirdList: [], // 3级菜单集合
      currentItem: {}, // 当前选中的1级菜单的信息
      currentSecondItem: {}, // 当前选中的2级菜单的信息
      showMenu: false, // 是否显示2-3级导航菜单
      showApp: false,
      showOnHold: false,
      doubleShowOnHold: false, // PC端双重校验是否显示on-holder
      feNetWork: '',
      navList: JSON.parse(localStorage.getItem('meauData')) || [],
      limit: {}, // 预申请的返回信息
      pcPayMenthod: {}, // haoyuanw add net  term
      netPayable: false, // net可支付状态 true可支付
      increaseStatus: false, // 可提额状态 true可
      isUseNt: false,
      showSdrLoginDialog: false // 是否显示SDR/SR登录弹框
    }
  },
  created() {
    // notes haoyuanw add 20220525 每次加载重置
    // localStorage.removeItem('from')
    this.loadCategory()
    this.feNetWork = this.getEnvUrl()
    if (this.login) {
      this.getUser()
      this.getPcNetTerm()
      this.loadSysRole()
      // this.onHolder()
      // this.getCreditLimit()
      this.isAllowNt()
      this.loadIncreaseStatus()
    }
  },
  mounted() {
    // add by cpgu 2022/06/13 begin

    // this.onHolder()

    // end by cpgu
  },
  filters: {
    // 保留几位小数
    toFixed(val, len) {
      return val && val !== 0 ? Number(val).toFixed(len) : '-'
    },
    // 数值过千加逗号，并保留几位小数
    numFormat(num, len = 2) {
      var c = num && num !== 0 ? Number(num).toFixed(len).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') : '0.00'
      return c
    },
    toFirstUpper: (value) => {
      return value.slice(0, 1).toUpperCase() + value.slice(1)
    }
  },
  computed: {
    showMenuApp() {
      return navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    },
    isIpad() {
      return navigator.userAgent.toLowerCase().match(/ipad/i)
    }

  },
  methods: {
    // 2.2.15 haoyuanw add SDR/SR 模拟登录弹框
    showSdrLogin() {
      this.showApp = false
      this.showSdrLoginDialog = true
    },
    closeSdrLoginDialog() {
      this.showSdrLoginDialog = false
    },
    async sdrLogin(sdrLoginForm) {
      // TODO 调用后端接口进行登录  参照tempLogin()
      let res = await postAction('/sys/sdr-login', sdrLoginForm)
      if (res.code === 200) {
        this.$ls.set('token', res.result.token)
        this.$ls.set('userInfo', res.result.userInfo)
        this.$ls.set('realname', res.result.userInfo.realname)
        Vue.prototype.login = true
        this.closeSdrLoginDialog()
        location.reload()
      } else {
        this.$message.warning(res.message)
      }
    },
    checkIsUseNt() {
      if (this.login) {
        getAction('/sys/user/queryById?id=' + JSON.parse(localStorage.getItem('pro__userInfo')).value.id).then(response => {
          if (response.success) {
            this.isUseNt = response.result.isUseNt
          } else {
            this.$message.warning(response.message)
          }
        })
      }
    },
    loadIncreaseStatus() {
      getAction('/v0.2/register/increase-status').then((response) => {
        if (response.success) {
          this.increaseStatus = response.result
        }
      })
    },
    isAllowNt() {
      getAction('/register/check-nt').then((response) => {
        if (response.success) {
          if (response.result) {
            this.netPayable = true
            this.tooltipText = 'Buy more,Repay more timely,Get more Credits'
            // this.tooltipText = 'Apply to increase net term limit to pay for more orders'
          } else {
            this.netPayable = false
            this.tooltipText = 'Currently only supports bricks and mortar store business owners in the US , and will be opened to more countries soon'
          }
        }
      })
    },
    onHolder() {
      let that = this

      let num = 0
      let isError = false
      let interval = setInterval(function () {
        if (isError && num < 30) {
          num++
          return
        }
        if (that.showOnHold) {
          clearInterval(interval)
        } else {
          getAction('/order/on-hold').then(response => {
            if (response.success) {
              that.showOnHold = response.result
              localStorage.setItem('showOnHold', that.showOnHold)
            }
          }).catch(err => {
            isError = true
            num = 0
          })
        }
      }, 1000)
    },
    retailerCheck() {
      this.$router.push({path: '/apply'})
    },
    loadSysRole() {
      loadSysRole(response => {
        this.menuList = response
      })
    },
    // haoyuanw add 2021-1109 net term 新增查询接口
    getPcNetTerm() {
      if (this.login) {
        getAction('/slope/prod/pc-net').then(response => {
          if (response.success) {
            if (response.result === null) {
              return
            }
            this.pcPayMenthod = response.result
          // this.pcStatus = this.pcPayMenthod.pcNetQualificationStatus
          } else {
            this.$message.warning(response.message)
          }
        }).catch(err => {
          this.$message.warning(err)
        })
      }
    },
    /**
     * 选中菜单只负责显示下级菜单
     */
    selectedMenu(item) {
      console.log(item)
      debugger
      if (item.name === 'Orders') {
        // this.$router.push({path: '/menu', params: {key: 'wholesale'}})
        this.$router.push({path: '/order/list'})
      } else if (item.name === 'Coupon') {
        this.$router.push({path: '/coupon'})
      } else if (item.name === 'My Profile') {
        this.$router.push({path: '/my-profile'})
      } else if (item.name === 'Get Sample') {
        this.$router.push({path: '/get-sample'})
      } else if (item.name === 'Service Order') {
        this.$router.push({path: '/serviceOrder'})
      }
      // 首先判断他有没有子级，如果有则不跳转
      if (item.childrenList.length > 0) {
        // 如果是1级菜单，则显示2级菜单
        this.checkedMenu = item.name
        this.firstMenuName = item.name
      } else {
        // 如果没有，则需要判断跳转到平台还是跳转到外部
        if (item.type === 'out') {
          window.location.href = item.path
        } else if (item.type === 'platform') {
          window.location.href = this.feNetWork + this.$tokenUrl(item.path, item.status)
        }
      }
    },
    /**
     * 点击二级菜单存在跳转,并且将选中的name进行更新
     */
    gotoRouter(num, item) {
      this.checkedMenu = item.name
      // 然后跳转，目前其他的菜单都跳转到平台
      if (item.type === 'in') {
        this.$router.push({path: item.path, params: {key: item.key}})
      } else if (item.type === 'platform') {
        window.location.href = this.feNetWork + this.$tokenUrl(item.path, item.status)
      }
    },
    addItems() {
      this.$router.push({
        path: '/credit-payment'
      })
    },
    getCreditLimit() {
      getCreditLimit('/balance/creditLimit').then(res => {
        console.log(res, '余额信息')
        if (res.code === 200) {
          this.limit = res.result
          console.log(this.limit, '限制信息')
        }
      })
    },
    getUser() {
      // 获取用户信息
      getAction('/sys/gain/user', {}).then(res => {
        this.$ls.set('realname', res.result.userInfo.realname)
      })
    },
    collapseChange(val) {
      localStorage.setItem('nav_checked', val)
      this.currentSecondItem = {}
      this.tempSecondId = ''
      this.thirdList = []
      let item = this.secondListNew[val]
      if (item === undefined) {
        return
      }
      // 更新三级菜单
      this.currentSecondItem = item
      this.tempSecondId = item.id
      if (item.childrenList.length > 0) {
        item.childrenList.forEach((element) => {
          element.name = element.cateName
            ? element.cateName
            : element.collectionName
          this.thirdList.push(element)
        })
      }
      localStorage.setItem('third_list', JSON.stringify(this.thirdList))
      this.thirdListNew = JSON.parse(localStorage.getItem('third_list'))
    },
    gotoPlatform(item) {
      if (item.name.includes('Order')) {
        // 如果是order的话，则跳转到wholesale订单，其他则继续跳转平台
        this.$router.push({path: '/menu', params: {key: 'wholesale'}})
        return
      }
      window.location.href = this.feNetWork + this.$tokenUrl(item.url, true)
    },
    handleClose() {},
    showLoginUpHandle() {
      // eslint-disable-next-line no-undef
      gtag('event', 'click', {
        'event_category': 'sign_up'
      })
      this.$emit('showLoginUp')
      this.showApp = false
    },
    showLoginHandle() {
      this.$emit('loginHandle', 'login')
      this.showApp = false
    },
    showMenuAction() {
      this.showApp = true
      if (this.login) {
        this.getPcNetTerm()
        this.checkIsUseNt()
      }
    },
    getEnvUrl() {
      let href = window.location.href
      let url = window.location.host
      if (href.indexOf('test') >= 0) {
        url = 'https://test-thalesmart-manage-ui.hupofintech.com'
        return url
      }
      if (href.indexOf('localhost') >= 0) {
        url = 'http://localhost:3000'
        return url
      }
      if (href.indexOf('shopvidi') >= 0) {
        url = 'https://p.shopvidi.com'
        return url
      }
      if (href.indexOf('192') >= 0) {
        url = 'http://192.168.3.54:3000'
        return url
      }
    },
    signOut() {
      const token = this.$ls.get('token')

      // add by cpgu 关闭ws 2023/03/07 begin
      try {
        closeWebsocket()
      } catch (e) {

      }
      // end by cpgu

      // 登出操作，
      // 1、调用登出接口 2、删除token
      if (token !== undefined && token !== null) {
        Vue.prototype.login = false
        // this.$ls.removeItem('token')
        localStorage.removeItem('pro__token')
        // haoyuanw add 2021-10-15 将localstorgae的 清除
        localStorage.removeItem('checkoutPath')
        // 返回到官网
        window.location.href = window.location.origin
        Logout('/sys/logout', token).then((response) => {
          if (response.success) {
            // 如果返回成功的话，将token清空

          } else {
            this.$message.warning(response.message)
          }
        })
      }
    },
    mobileGotoMenu(level, item) {
      localStorage.setItem('page_form', 'menu')
      if (this.currentItem.collectionName) {
        this.gotoCollection(level, item)
      } else {
        this.gotoProduct(level, item)
      }
    },
    // 跳转到collection页面
    gotoCollection(level, item) {
      // notes haoyuanw add 20220525 判断哪里点击导航，如果上面的则
      localStorage.setItem('from', 'nav')
      localStorage.setItem('isNewProduct', '')
      localStorage.setItem('isNewProductId', '')
      if (this.showMenuApp || this.isIpad) {
        this.showApp = false
      }
      if (level === 1) {
        // this.showMenu = false
        let menuLevel = this.currentItem.seoUrl.split('/').filter(word => word)
        this.$router.push({
          name: 'collection',
          params: {firstName: menuLevel[0]}
        })
      } else if (level === 2) {
        if (item.name === 'New Releases') {
          localStorage.setItem('isNewProduct', item.name)
          localStorage.setItem('isNewProductId', item.id)
        }
        // this.showMenu = false
        let menuLevel = this.currentSecondItem.seoUrl.split('/').filter(word => word)
        this.$router.push({
          name: 'collection',
          params: {firstName: menuLevel[0],
            secondName: menuLevel[1]}
        })
        // this.$router.go(0)

        // } else {
        //   this.showMenu = false
        //   let menuLevel = this.currentSecondItem.seoUrl.split('/').filter(word => word)
        //   this.$router.push({
        //     name: 'collection',
        //     params: {firstName: menuLevel[0],
        //       secondName: menuLevel[1]}
        //   })
        // }
      } else if (level === 3) {
        // this.showMenu = false
        let menuLevel = item.seourl.split('/').filter(word => word)
        this.$router.push({
          name: 'collection',
          params: { firstName: menuLevel[0],
            secondName: menuLevel[1],
            thirdName: menuLevel[2]}
        })
      }
      // this.showMenu = false
    },
    /**
     * 跳转到商品列表，将1级id的整体列表传过去，然后将选中的id和name传过去
     */
    gotoProduct(level, item) {
      // add by cpgu 2022/11/16 添加以下代码，适配分类后添加collection问题 begin
      if (this.currentItem['barType'] === 'collection') {
        this.gotoCollection(level, item)
        return
      }
      // end by cpgu

      if (!this.showMenuApp) {
        localStorage.setItem('page_form', 'nav')
      } else {
        localStorage.setItem('page_form', 'menu')
      }
      // notes haoyuanw add 20220525 判断哪里点击导航，如果上面的则
      localStorage.setItem('from', 'nav')
      localStorage.setItem('isNewProduct', '')
      localStorage.setItem('isNewProductId', '')
      // 如果是移动端关闭弹窗
      if (this.showMenuApp || this.isIpad) {
        this.showApp = false
      }

      // const params = {}
      // let menuList = []
      // 如果是1级的话
      if (level === 1) {
        // menuList.push(this.currentItem)
        // params.menuList = menuList
        // this.showMenu = false
        let menuLevel = this.currentItem.seoUrl.split('/').filter(word => word)
        this.$router.push({
          name: 'category',
          params: {firstName: menuLevel[0]}
        })
      } else if (level === 2) {
        // menuList.push(this.currentItem)
        // params.menuList = menuList
        // params.secondItem = this.currentSecondItem
        if (item.name === 'New Releases') {
          localStorage.setItem('isNewProduct', item.name)
          localStorage.setItem('isNewProductId', item.id)
        }
        // this.showMenu = false
        let menuLevel = this.currentSecondItem.seoUrl.split('/').filter(word => word)
        this.$router.push({
          name: 'category',
          params: {firstName: menuLevel[0],
            secondName: menuLevel[1]}
        })
      } else if (level === 3) {
        // menuList.push(this.currentItem)
        // params.menuList = menuList
        // params.secondItem = this.currentSecondItem
        // params.thirdItem = item
        // this.showMenu = false
        let menuLevel = item.seoUrl.split('/').filter(word => word)
        this.$router.push({
          name: 'category',
          params: { firstName: menuLevel[0],
            secondName: menuLevel[1],
            thirdName: menuLevel[2]}
        })
      }
      // const postStr = JSON.stringify(params)
      // this.showMenu = false
    },
    /**
     * 鼠标放在二级菜单的时候更改三级菜单
     */
    changeThird(item) {
      this.currentSecondItem = {}
      this.currentSecondItem = item
      this.tempSecondId = ''
      this.tempSecondId = item.id
      // 更新三级菜单
      this.thirdList = []
      if (item.childrenList.length > 0) {
        item.childrenList.forEach((element) => {
          element.name = element.cateName
            ? element.cateName
            : element.collectionName
          this.thirdList.push(element)
        })
      }
      localStorage.setItem('third_list', JSON.stringify(this.thirdList))
      this.thirdListNew = JSON.parse(localStorage.getItem('third_list'))
    },
    disableNextMenu() {
      this.currentItem = {}
      this.showMenu = false
      this.doubleShowOnHold = true
    },
    /**
     * 鼠标放到1级菜单的时候，加载所有2级，以及第一个2级的三级
     */
    showNextMenu(item) {
      if (item.id === '') {
        return ''
      }
      this.doubleShowOnHold = false

      // 更新当前选中菜单信息
      this.currentItem = {}
      this.currentItem = item
      this.firstListName = item.name
      localStorage.setItem('first_list_name', item.name)
      this.currentSecondItem = {}
      this.tempSecondId = ''
      this.activeNames = []
      let defaultSecondIdx = item.childrenList.length > 1 ? 1 : 0
      // notes haoyuanw  add 20220527 如果是移动端则不默认展开显示的二级 会有问题
      if (!this.showMenuApp) {
        this.currentSecondItem = item.childrenList[defaultSecondIdx]
        this.tempSecondId = item.childrenList[defaultSecondIdx].id
      } else {
        localStorage.setItem('isNewProduct', '')
        localStorage.setItem('isNewProductId', '')
      }

      // 因为有id，直接获取该对象下面的chirdrenList赋值给2级，然后找到第一个的chirdren
      this.secondListNew = []
      this.thirdListNew = []
      if (item.childrenList.length > 0) {
        item.childrenList.forEach((element) => {
          element.name = element.cateName
            ? element.cateName
            : element.collectionName
          this.secondListNew.push(element)
        })
        // notes 如果不是移动端则赋值第一个三级
        if (!this.showMenuApp) {
          item.childrenList[defaultSecondIdx].childrenList.forEach((element) => {
            element.name = element.cateName
              ? element.cateName
              : element.collectionName
            this.thirdListNew.push(element)
          })
        }
      }
      localStorage.setItem('second_list', JSON.stringify(this.secondListNew))
      localStorage.setItem('third_list', JSON.stringify(this.thirdListNew))
      this.showMenu = true
    },
    /**
     * 加载页面的一级分类和collection，这里全局只加载一次所以就不封装了
     */
    async loadCategory() {
      // 判断localstorage有没有
      // if (localStorage.getItem('meauData') === undefined || localStorage.getItem('meauData') === null) {
      let resultNavList = []
      // 这里要同步加载，要先加载collection 在加载 category保证显示顺序的正常
      let res = await getAction('/collection-info/all-list')
      if (res.success) {
        const result = this.updateNavList(res.result)
        resultNavList.push(...result)
      } else {
        this.$message.warning(res.message)
      }
      res = await getAction('/tsCategory/tsCateInfo/all-list')
      if (res.success) {
        const result = this.updateNavList(res.result)
        resultNavList.push(...result)
      } else {
        this.$message.warning(res.message)
      }
      this.navList = resultNavList
      localStorage.setItem('meauData', JSON.stringify(this.navList))
      // }
      // this.navList = JSON.parse(localStorage.getItem('meauData'))
    },
    /**
     * 封装处理一级分类以及
     */
    updateNavList(result) {
      let resultNavList = []
      if (result.length <= 0) {
        this.$message.warning('No Data')
        return ''
      }

      result.forEach((element) => {
        element.name = element.collectionName ? element.collectionName : element.cateName
        // add by cpgu 2022/11/16 添加以下if，对于collection begin
        if (element['barType'] === 'collection' && element.name !== 'Featured') {
          resultNavList.push(element)
        } else {
          // 组装一个 NewProduct 放到2级的集合里
          const newProdcut = {}
          newProdcut.id = 'new' + element.id
          newProdcut.seoUrl = element.seoUrl + '/new-product'
          const type = element.cateName ? 'cateName' : 'collectionName'
          newProdcut.name = 'New Releases'
          newProdcut[type] = 'New Releases'
          newProdcut.childrenList = []
          element.childrenList.splice(0, 0, newProdcut)
          resultNavList.push(element)
        }
      })
      return resultNavList
    },
    handleChange(val) {
      console.log(val)
    },
    gotoUrl(item) {
      this.$router.push(item.url)
    }
  },
  watch: {
    isFirstOrder: {
      handler: function(n, o) {
        this.isFirstOrder = n
      },
      deep: true,
      immediate: true
    },
    isShowNt: {
      handler: function(n, o) {
        this.isShowNt = n
      },
      deep: true,
      immediate: true
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.money_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;

}
.line_between{
  width: 1px;
  height: 24px;
  background: #E1E1E1;
  margin: 0 5px;
}
.first-vidi-menu{
  line-height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.second-vidi-menu{
  line-height: 40px;
  margin-left: 20px;
}
.el-collapse {
  border: none;
}
.wap-list {
  p {
    line-height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  > h4 {
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 10px;
  }
  h4 {
    font-size: 14px;
    font-family: Graphik;
    font-weight: 800;
    line-height: 40px;
    color: #262b2f;

    &:nth-last-child(1) {
      font-weight: normal;
    }
    i {
      margin-right: 5px;
      font-size: 20px;
    }
  }
}
.apply-border{
  .type{
    text-align: center;
    width: 36%;
    line-height: 30px;
    height: 30px;
    font-size: 12px;
    background: #262B2F;
    color: #FFFFFF;
    cursor: pointer;
  }
  .info{
    // width: 49%;
    padding: 10px 10px;
    // border-top: 1px solid #ebeef5;
    .info-name{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-size: 12px;
      .status{
        background: #E1E1E1;
        border: 1px solid #E1E1E1;
        border-radius: 2px;
        padding: 4px 8px;
        margin-left: 4px;
      }
      .color-green{
        color: #41B76A;
      }
      .color-red{
        color: #F77073;
      }

      .color-gray{
        color: #8F8F8F;
      }
      .color-blue{
        color: #0B8CF4;
      }
      .color-brown{
        color: #C3824B;
      }
      .color-orange{
        color: #FF4812;
      }
    }
    .money{
      font-size: 18px;
      font-family: Graphik;
      font-weight: 500;
      color: #262B2F;
      display: flex;
      justify-content: space-between;
    }
  }
  border-bottom: 1px solid #ebeef5;
  display: flex;
  align-items: center;
}
.wap-child {
  .wap-nav {
    line-height: 30px;
    &:nth-last-child(1) {
      padding-bottom: 20px;
    }
  }
  h3 {
    position: relative;
    font-size: 14px;
    font-family: Graphik;
    font-weight: 800;
    padding: 20px 0;
    color: #262b2f;
    text-align: center;
    i {
      position: absolute;
      left: 0;
      top: 20px;
    }
  }
  h4 {
    font-size: 14px;
    font-family: Graphik;
    font-weight: 800;

    color: #262b2f;
  }
}
.nav-container {
  position: relative;
}
.wap-top,
.nav-bg {
  display: none;
}
.nav {
  position: relative;
  width: 1400px;
  max-width: 90%;
  line-height: 20px;
  margin: 0 auto 0;
  padding-top: 30px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  color: #262b2f;
  font-size: 14px;
  font-family: Graphik;
  font-weight: 500;
  line-height: 30px;
  color: #262b2f;
  > div {
    padding-right: 15px;
    cursor: pointer;
  }
  .first {
    border-right: 1px solid #e1e1e1;
    margin-right: 20px;
  }
}

/**
 *  haoyuanw  add  样式可能不是很好，后续可以完善
 */
.categery-collection-menu-border {
  position: relative;
  background: white;
  min-width: 1200px;
  width: auto;
  z-index: 8;
  margin-top: 0px;
}
.categery-collection-menu-content {
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  width: 80%;
}
.second-menu {
  margin-top: 20px;
  width: 200px;
}
.third-menu {
  width: 500px;
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.second-left {
  margin-left: 10px;
  width: 250px;
  font-size: 14px;
  font-family: Graphik;
  font-weight: 400;
  line-height: 33px;
  color: #262b2f;
  opacity: 1;
  text-decoration: none;
}
.second-left:hover {
  font-weight: 600;
  text-decoration: none;
}
.el-divider--vertical {
  height: auto;
  min-height: 200px;
  margin-top: 20px;
}
.el-divider--horizontal {
  margin: 20px 0 0;
}
.second-content {
  font-weight: 400;
}
.second-content:hover {
  background: #f4f4f4;
  font-weight: 600;
  text-decoration: none;
}
.second-content-selected {
  background: #f4f4f4;
  font-weight: 600;
  text-decoration: none;
}
.third-content {
  color: #8f8f8f;
  text-decoration: none;
  margin: 0 20px;
}
.third-content:hover {
  color: #262b2f;
  font-weight: 500;
}
.second-left-content {
  display: inline-block;
  width: 100%;
  height: 100%;
  margin-left: 10px;
  font-size: 14px;
  font-family: Graphik;
  line-height: 33px;
  color: #262b2f;
  opacity: 1;
  text-decoration: none;
}
.third-menu-border {
  width: 250px;
  font-size: 14px;
  font-family: Graphik;
  font-weight: 400;
  line-height: 33px;
  opacity: 1;
}
.footer {
  height: 15px;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.05);
}
.first-titel-seleted {
  position: relative;
  &::after {
    position: absolute;
    left: 0;
    bottom: -20px;
    content: "";
    width: 100%;
    height: 1px;
    background: #000;
  }
}
.wap-body {
  position: relative;
  width: 100%;
  height: calc(100vh - 90px);
  overflow: auto;
  box-sizing: border-box;
  padding: 10px;
}
.wap-top {
  display: block;
  position: relative;

  box-sizing: border-box;
  padding: 10px;
  background: #333333;
  img {
    display: block;
    width: 100px;
    margin: 0 auto 10px;
  }
  p {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  span {
    display: block;
    margin: 0 5px;
    width: 88px;
    height: 26px;
    font-size: 12px;
    font-family: Graphik;
    font-weight: 500;
    line-height: 26px;
    color: #ffffff;
    text-align: center;
    background: #444444;
  }
}
.shoping_button{
  margin-left: 30px;
  cursor: pointer;
  width: 130px;
  border: 1px solid #F6F5F3;
  border-radius: 17px;
  height: 30px;
  background: #fff;
  font-size: 12px;
  text-align: center;
  line-height: 30px;
  padding: 0 5px;
}

.on-hold{
  background: rgba(250, 243, 236, 0.39);
  text-align: center;
  height: 50px;
  line-height: 50px;
  img{position: relative;}
  span:nth-of-type(2){
    text-decoration: underline;
    cursor: pointer;
  }
  .on-hold-text label{color: #FF511E;}
}
.net-term{
  p{
    margin: 5px 0px;
    &:nth-child(1){
      text-decoration: underline;
      text-underline-offset: 5px;
      font-family: Satoshi-Bold;
      cursor:pointer;
    }
  }
}

@media screen and (max-width: 600px) {
  .on-hold-text{
  text-align: left;
  font-size: 12px;
}
  .on-hold{
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 5px;
    span{
      display: inline-block;
      line-height: 16px;
    }
    span:nth-of-type(1){
      width: 58vw;

    }
  }

}

@media screen and (max-width: 320px) {

  .on-hold{
    span:nth-of-type(1){
      width: 45vw;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/components/nav.vue